/**
 * Servizio — schemi per il catalogo servizi extra (F-009.6).
 *
 * Righe libere gestite dall'ADMIN (CRUD) e acquistabili self-service dagli
 * agenti (addebito wallet, reason DEBIT_SERVIZIO).
 *
 * Boundary HTTP: `prezzoCents` BigInt → stringa; input admin in euro (number)
 * convertito a cents server-side via `euroToCents`.
 */
import { z } from 'zod';
/** Servizio serializzato (response). `prezzoCents` come stringa. */
export const servizioResponseSchema = z.object({
    id: z.string(),
    nome: z.string(),
    descrizione: z.string().nullable(),
    prezzoCents: z.string(),
    attivo: z.boolean(),
    updatedAt: z.string().nullable(),
});
export const servizioListResponseSchema = z.object({
    items: z.array(servizioResponseSchema),
});
const nomeSchema = z
    .string({ required_error: 'Nome obbligatorio' })
    .trim()
    .min(1, { message: 'Nome obbligatorio' })
    .max(200, { message: 'Nome troppo lungo' });
const descrizioneSchema = z.string().trim().max(1000, { message: 'Descrizione troppo lunga' });
const prezzoEuroSchema = z
    .number({ required_error: 'Prezzo obbligatorio' })
    .nonnegative({ message: 'Il prezzo non può essere negativo' })
    .max(100000, { message: 'Prezzo troppo alto' });
/** Input creazione servizio (ADMIN). */
export const createServizioInputSchema = z.object({
    nome: nomeSchema,
    descrizione: descrizioneSchema.optional(),
    prezzoEuro: prezzoEuroSchema,
    attivo: z.boolean().optional(),
});
/** Input aggiornamento servizio (ADMIN). Tutti i campi opzionali (patch). */
export const updateServizioInputSchema = z
    .object({
    nome: nomeSchema.optional(),
    descrizione: descrizioneSchema.nullable().optional(),
    prezzoEuro: prezzoEuroSchema.optional(),
    attivo: z.boolean().optional(),
})
    .refine((v) => Object.keys(v).length > 0, { message: 'Nessun campo da aggiornare' });
/**
 * Input acquisto servizio (AGENTE). `idempotencyKey` generato dal client (UUID)
 * per evitare doppio addebito su doppio click / retry di rete.
 */
export const acquistaServizioInputSchema = z.object({
    idempotencyKey: z
        .string()
        .trim()
        .min(8, { message: 'idempotencyKey troppo corto' })
        .max(255, { message: 'idempotencyKey troppo lungo' }),
});
//# sourceMappingURL=servizio.js.map